// import cartUtil from "../helpers/cartUtil";
// import Util from "../helpers/util";

// var CartObject = new cartUtil();
// var UtilObject = new Util();
var customerID;
var oldPhone, oldEmail, OTP;
var deviceTypeCustSerOrdersPage;
export default class Vendor_security {
  constructor() {
    // this.allCookies = UtilObject.getAllCookies();
    //id's of the fields
    this.fullNameDisplayDesk = $("#fullNameDisplayDeskCustomerServicing");
    this.genderDisplayDesk = $("#genderDisplayDeskCustomerServicing");
    this.dobDisplayDesk = $("#dobDisplayDeskCustomerServicing");
    this.mobNoDisplayDesk = $("#mobNoDisplayDeskCustomerServicing");
    this.emailIdDisplayDesk = $("#emailIdDisplayDeskCustomerServicing");
    this.passwordConfirmationPage = $("#passwordConfirmationPage");
    this.passwordConfirmationPageBtn = $("#passwordConfirmationPageBtn");

    this.mobileInputAccount = $("#mobileInputAccount");

    //OTP MODAL
    // this.verifyOtpModal = $("#verifyOtpModalAccount");
    this.otpInputVerify = $("#otpInputVerifyAccount");
    this.otpError = $("#otpErrorAccount");
    this.verifyOTPBtn = $("#verify-OTP-btn-Account");

    //errors
    this.fullNameDisplayDeskError = $(
      "#fullNameDisplayDeskErrorCustomerServicing",
    );

    this.mobNoDisplayDeskError = $("#mobNoDisplayDeskErrorCustomerServicing");

    this.emailIdDisplayDeskError = $(
      "#emailIdDisplayDeskErrorCustomerServicing",
    );

    this.genderDisplayDeskError = $("#genderDisplayDeskErrorCustomerServicing");

    this.dobDisplayDeskError = $("#dobDisplayDeskErrorCustomerServicing");

    this.passwordConfirmationPageError = $("#passwordConfirmationPageError");

    //button register profile
    this.ProfileUploadBtn = $("#ProfileUploadBtn");

    //security page stuff
    this.forgotpassModalForServicingSecurityPage = $(
      "#forgotpassModalForServicingSecurityPage",
    );
    //forgot password
    this.callForgetPasswordmodalAccountPageBtn = $(
      ".callForgetPasswordmodalAccountPageBtn",
    );
    //change password toggle
    this.toggleChangePasswordBtn = $("#toggleChangePasswordBtn");
    this.forgotBtn = $("#forgotBtnAccount");
    this.Current_Password = $("#Current_PasswordAccount");
    this.New_Password = $("#New_Password");
    this.Confirm_Password = $("#Confirm_PasswordAccount");
    //otp forgot password
    this.forgotPswdMobileNumberInput = $(".customerServicingUPhone");
    this.sendOTPForgotPasswordButton = $("#send-otp-ForgetPasswordAccount");
    this.OTPInputForgotPassword = $("#otp-inputForgetPasswordAccount");
    this.saveNewPasswordBtnForgotPassword = $(
      "#saveNewForgetPasswordAccountBtn",
    );
    this.saveNewPasswordInputForgotPassword = $("#newForgetPasswordAccount");
    this.resendOTPForgotPasswordButton = $("#resend-otp-ForgetPasswordAccount");
    this.verifyOTPBtnForgotPassword = $("#saveNewPasswordAccountVerifyBtn");
    this.OTPSuccessForgotPassword = $("#OTP-successAccount");
    this.mobileLabelForgotPassword = $("#mobile-labelForgetPasswordAccount");
    this.OTPLabelForgotPassword = $("#otp-labelForgetPasswordAccount");
    this.newPasswordLabelForgotPassword = $(
      "#new-password-labelForgetPasswordAccount",
    );
    this.successNewPasswordForgotPassword = $("#success-New-PasswordAccount");

    //show the fields once toggle btn is enabled
    this.showTheFieldsAfterToggle = $(".showTheFieldsAfterToggle");

    //submit btn for sec page
    this.uploadBtnforSecPage = $("#uploadBtnforSecPage");

    //error msgs
    this.Current_PasswordError = $("#Current_PasswordError");
    this.New_PasswordError = $("#New_PasswordError");
    this.Confirm_PasswordError = $("#Confirm_PasswordError");

    //all pages show and d-none id's -Orders
    this.vendorDesktopPastOrder = $("#vendorDesktopPastOrder");
    this.MobilePastOrder = $("#MobilePastOrder");

    //all pages show and d-none id's- favourites

    this.DesktopFavourites = $("#DesktopFavourites");
    this.MobileFavourites = $("#MobileFavourites");

    //all pages show and d-none id's- address
    this.EditDeleteBtnDesktop = $("#EditDeleteBtnDesktop");
    this.EditDeleteBtnMobile = $("#EditDeleteBtnMobile");

    //photo
    this.mobilePhoto = $("#mobilePhoto");
    this.desktopPhoto = $("#desktopPhoto");

    //desktop customer servicing haeder

    // this.custSerHeaderMobOne = $("#custSerHeaderMobOne");
    // this.custSerHeaderOne = $("#custSerHeaderOne");

    //Registering Events
    // this.confirmLogInOfCustomer();
    this.bindEvents();
  }

  bindEvents = () => {
    this.ProfileUploadBtn.on("click", this.doFormAction);

    //toggle btn onclick function
    this.toggleChangePasswordBtn.on("click", this.showOtherFieldsAction);

    //submit btn for sec
    this.uploadBtnforSecPage.on("click", this.securityPageValidation);

    //upload profile
    // $(window).on("load", () => { this.getAccountDetails(); });
    this.passwordConfirmationPageBtn.on("click", this.submitPasswordCheck);

    //verify OTP
    this.verifyOTPBtn.on("click", this.verifyOtp);

    //forgot password
    this.sendOTPForgotPasswordButton.on("click", this.sendOtpForgotPassword);
    this.saveNewPasswordBtnForgotPassword.on(
      "click",
      this.doSaveNewForgotPassword,
    );
    this.resendOTPForgotPasswordButton.on("click", this.sendOtpForgotPassword);
    this.verifyOTPBtnForgotPassword.on("click", this.doVerifyOTP);

    //widthwise show and d-none for Past orders
    // for desktop - bigger and mobile and tab view - smaller
    var w = $(window).width();

    if (w < 821) {
      this.vendorDesktopPastOrder.addClass("d-none");
      this.MobilePastOrder.removeClass("d-none");
    } else {
      this.MobilePastOrder.addClass("d-none");
      this.vendorDesktopPastOrder.removeClass("d-none");
    }

    // for desktop and tab view - bigger and mobile- smaller
    var width_fav = $(window).width();

    if (width_fav < 573) {
      this.DesktopFavourites.addClass("d-none");
      this.MobileFavourites.removeClass("d-none");
    } else {
      this.MobileFavourites.addClass("d-none");
      this.DesktopFavourites.removeClass("d-none");
    }

    // address
    var width_address = $(window).width();

    if (width_address < 821) {
      this.EditDeleteBtnDesktop.addClass("d-none");
      this.EditDeleteBtnMobile.removeClass("d-none");
    } else {
      this.EditDeleteBtnMobile.addClass("d-none");
      this.EditDeleteBtnDesktop.removeClass("d-none");
    }

    // admin phtoto
    var width_photo = $(window).width();

    if (width_photo < 573) {
      this.desktopPhoto.addClass("d-none");
      this.mobilePhoto.removeClass("d-none");
    } else {
      this.mobilePhoto.addClass("d-none");
      this.desktopPhoto.removeClass("d-none");
    }

    //checking the size of the screen
    var screenWidthOrders = $(window).width();

    if (screenWidthOrders < 768) {
      //show mobile view

      deviceTypeCustSerOrdersPage = "mobile";
      $("#MobilePastOrder").removeClass("d-none");
    } else {
      deviceTypeCustSerOrdersPage = "desktop";
      $("#vendorDesktopPastOrder").removeClass("d-none");
    }

    if (screenWidthOrders < 991) {
      // $("#sidebarMenu").css("margin-top", "7rem");
    } else {
      // $("#sidebarMenu").css("margin-top", "5rem");
    }

    //Click events for sidebar
    $(".nav-orders").on("click", this.sidebarFunction);
    $(".nav-account").on("click", this.sidebarFunction);
    $(".nav-profile").on("click", this.sidebarFunction);
    $(".nav-security").on("click", this.sidebarFunction);
    $(".nav-address").on("click", this.sidebarFunction);
    $(".nav-favourites").on("click", this.sidebarFunction);
    $(".nav-offers").on("click", this.sidebarFunction);
    $(".nav-referral").on("click", this.sidebarFunction);
    $(".nav-help").on("click", this.sidebarFunction);
    $(".nav-logOut").on("click", this.logOutUser);
  };

  sidebarFunction = (event) => {
    var activeEvent = $("#sidebarMenu").find(".active");

    //add and remove active class from sidebar (causes darkening if the text)

    activeEvent[0].classList.remove("active");

    //get the page to be shown
    var page =
      event.currentTarget.classList[event.currentTarget.classList.length - 1];

    if (page == "nav-account" || page == "collapsed") {
      event.currentTarget.classList.add("active");
    } else {
      event.currentTarget.classList.add("active");
      $(".currentlyActive").addClass("d-none");
      $(".currentlyActive").removeClass("d-currentlyActive");
      $("#sidebarMenu").removeClass("show");
    }

    if (page == "nav-orders") {
      $(".customerServicingOrders").addClass("currentlyActive");
      $(".customerServicingOrders").removeClass("d-none");
    } else if (page == "nav-profile") {
      $(".customerAccountProfile").addClass("currentlyActive");
      $(".customerAccountProfile").removeClass("d-none");
    } else if (page == "nav-security") {
      $(".custAccountSecurity").addClass("currentlyActive");
      $(".custAccountSecurity").removeClass("d-none");
    } else if (page == "nav-address") {
      $(".custAccountAddress").addClass("currentlyActive");
      $(".custAccountAddress").removeClass("d-none");
    } else if (page == "nav-favourites") {
      $(".customerServicingFavorites").addClass("currentlyActive");
      $(".customerServicingFavorites").removeClass("d-none");
    } else if (page == "nav-offers") {
      $(".customerServicingOrders").addClass("currentlyActive");
      $(".customerServicingOrders").removeClass("d-none");
    } else if (page == "nav-referral") {
      $(".customerServicingOrders").addClass("currentlyActive");
      $(".customerServicingOrders").removeClass("d-none");
    } else if (page == "nav-help") {
      $(".vendorConfirmationHelpPageDesktop").addClass("currentlyActive");
      $(".vendorConfirmationHelpPageDesktop").removeClass("d-none");
    }
  };

  showOtherFieldsAction = (e) => {
    e.preventDefault();

    if (e.currentTarget.ariaPressed == "true") {
      this.showTheFieldsAfterToggle.addClass("d-none");
    } else if (e.currentTarget.ariaPressed == "false") {
      this.showTheFieldsAfterToggle.removeClass("d-none");
    }

    //this.showTheFieldsAfterToggle.removeClass("d-none");
  };

  //checking if entered details are valid or not
  doFormAction = async (e) => {
    e.preventDefault();

    //name
    let isNameValidated = this.Name_validate();
    if (isNameValidated) {
      this.fullNameDisplayDeskError.html("");
    }

    //gender
    let isGenderValidated = this.Gender_validate();
    if (isGenderValidated) {
      this.genderDisplayDeskError.html("");
    }

    //dob
    let isDobValidated = this.Dob_validate();
    if (isDobValidated) {
      this.dobDisplayDeskError.html("");
    }

    //mobNo
    let isMobNoValidated = this.MobNo_validate();
    if (isMobNoValidated) {
      this.mobNoDisplayDeskError.html("");
    }

    //emailid
    let isEmailValidated = this.Email_validate();
    if (isEmailValidated) {
      this.emailIdDisplayDeskError.html("");
    }

    //checking if all fields are right
    if (
      isNameValidated &&
      isGenderValidated &&
      isDobValidated &&
      isMobNoValidated &&
      isEmailValidated
    ) {
      let phnoIsUnique = await this.phnoIsUnique_validate();
      let emailIsUnique = await this.emailIsUnique_validate();

      if (phnoIsUnique && emailIsUnique) {
        this.emailIdDisplayDeskError.html("");
        this.mobNoDisplayDeskError.html("");

        window.$("#checkPasswordConfirmationPage").modal("show");
      }
    }
  };

  //validate function
  MobNo_validate = () => {
    let flag = true;
    var phoneno = /^\d{10}$/;
    if (!this.mobNoDisplayDesk.val().match(phoneno)) {
      this.mobNoDisplayDeskError.html(
        "Please enter only 10 digits for mobile number",
      );

      flag = false;
    }

    return flag;
  };

  Name_validate = () => {
    let flag = true;
    var name = /^([a-zA-Z ]){3,100}$/;

    if (
      !(
        this.fullNameDisplayDesk.val().match(name) &&
        this.fullNameDisplayDesk.val().length >= 3 &&
        this.fullNameDisplayDesk.val().length <= 100
      )
    ) {
      this.fullNameDisplayDeskError.html(
        "Name must be min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  // //gender validation
  Gender_validate = () => {
    let flag = true;

    if (this.genderDisplayDesk.val() == null) {
      this.genderDisplayDeskError.html("Please enter a valid gender");

      flag = false;
    }

    return flag;
  };

  //email id validation
  Email_validate = () => {
    let flag = true;
    var emailexample =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.emailIdDisplayDesk.val().match(emailexample)) {
      this.emailIdDisplayDeskError.html("Please enter a valid email");

      flag = false;
    }

    return flag;
  };

  //dob validation
  Dob_validate = () => {
    let flag = true;

    var dobPattern = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (!this.dobDisplayDesk.val().match(dobPattern)) {
      this.dobDisplayDeskError.html("Please enter a valid birth date");

      flag = false;
    }

    return flag;
  };

  //call to get customer profile
  getAccountDetails = () => {
    // Customer_ID: customerID,

    $.ajax({
      url: baseURL + "api/customer/Account/GetUserDetails",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: {
        Customer_ID: customerID,
      },
      success: (result) => {
        $(".customerServicingName").val(result.Customer_Name);
        $(".customerServicingGender").val(result.Gender);
        $(".customerServicingDateOfBirth").val(result.Date_Of_Birth);
        $(".customerServicingUPhone").val(result.Phone_Number);
        $(".customerServicingUEmail").val(result.Email);

        //ruthvi's code for referal code api integration
        $(".referalCode").html(result.Referral_code);

        oldPhone = result.Phone_Number;
        oldEmail = result.Email;

        this.changeAccountDisplayOnHeader(result);
      },
      error: (result) => {},
    });
  };

  changeAccountDisplayOnHeader = (account) => {
    var desktopName = account.Customer_Name;
    if (desktopName.length > 10) {
      desktopName = desktopName.substring(0, 8) + "..";
    }
    //For Desktop Name Change
    $(".accountNameDesktop").html(
      `<a href="${baseURL}customer/account" class="truncate-account-name-desktop" style="color:black;">${desktopName}</a>`,
    );
    // $(".accountNameMobile").html(
    //   `<a href="${baseURL}customer/account" class="truncate-account-name">${result.Customer_Name}</a>`
    // );
    $(".customerProfileImage").html(
      `<img src="https://img.icons8.com/color/32/null/circled-user-male-skin-type-7--v1.png"/>`,
    );
  };

  //upload user information
  uploadUpdatedProfile = () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;
    // Customer_ID: customerID,

    $.ajax({
      url: baseURL + "api/customer/Account/UpdateCustomer",
      type: "POST",
      data: {
        Customer_ID: customerID,
        Customer_Name: this.fullNameDisplayDesk.val(),
        Gender: this.genderDisplayDesk.val(),
        Date_Of_Birth: this.dobDisplayDesk.val(),
        Phone_Number: this.mobNoDisplayDesk.val(),
        Email: this.emailIdDisplayDesk.val(),
      },
      success: (result) => {
        $("#passwordConfirmationPage").val("");
        $("#passwordConfirmationPageError").html("");
        window.$("#checkPasswordConfirmationPage").modal("hide");
        window.$("#profileUpdatedChangedSuccesfully").modal("show");
        this.getAccountDetails();
      },
      error: (result) => {},
    });
  };

  //check if user has entered a different number
  phnoIsUnique_validate = async () => {
    let flag = true;

    if (this.mobNoDisplayDesk.val() == oldPhone) {
      flag = true;
    } else {
      var phone = false;

      //Check if phone is unique
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          //check if phone number exists
          url: baseURL + "api/customer/Account/logInPhoneCustomer",

          //headers: { Authorization: X_API_KEY },

          data: {
            Phone_Number: this.mobNoDisplayDesk.val(),
          },
          success: () => {
            phone = true;
            resolve();
          },
          error: () => {
            this.mobNoDisplayDeskError.html("Phone Number already Exists");
            resolve();
          },
        });
      });

      if (phone) {
        flag = true;
      } else {
        flag = false;
      }
    }

    return flag;
  };

  emailIsUnique_validate = async () => {
    let flag = true;

    if (this.emailIdDisplayDesk.val() == oldEmail) {
      flag = true;
    } else {
      var email = false;

      //check if email is unique
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          //check if phone number exists
          url: baseURL + "api/customer/Account/emailIsUnique",

          //headers: { Authorization: X_API_KEY },
          data: {
            cutomerEmail_Address: this.emailIdDisplayDesk.val(),
          },
          success: () => {
            email = true;
            resolve();
          },
          error: () => {
            if ($("#emailIdDisplayDeskCustomerServicing").val() == "") {
              this.emailIdDisplayDeskError.html("Email Address is mandatory");
            } else {
              this.emailIdDisplayDeskError.html("Email Address already exists");
            }
            resolve();
          },
        });
      });

      if (email) {
        flag = true;
      } else {
        flag = false;
      }
    }

    return flag;
  };

  //password check
  submitPasswordCheck = async () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;

    // Customer_ID: customerID,

    $.ajax({
      type: "POST",
      url: baseURL + "api/customer/Account/userPasswordCheck",
      //headers: { Authorization: X_API_KEY },
      data: {
        Customer_ID: customerID,
        Password: this.passwordConfirmationPage.val(),
      },
      success: (res) => {
        var code = res.Code;

        if (code == 2) {
          this.passwordConfirmationPageError.html("Password is incorrect");
        } else {
          //check if number is changed
          if (this.mobNoDisplayDesk.val() == oldPhone) {
            this.uploadUpdatedProfile();
          } else {
            //number is changed
            window.$("#checkPasswordConfirmationPage").modal("hide");
            window.$("#verifyOtpModalAccount").modal("show");
            this.sendOtp();
          }
        }
      },
      error: (res) => {},
    });
  };

  sendOtp = () => {
    $.ajax({
      type: "POST",
      url: baseURL + "api/customer/Account/sendOTPSignUp",
      //headers: { Authorization: X_API_KEY },
      data: {
        Phone_Number: this.mobNoDisplayDesk.val(),
        Email_Address: this.emailIdDisplayDesk.val(),
      },
      success: (data) => {
        OTP = data.OTP;
      },
      error: (err) => {},
    });
  };

  verifyOtp = () => {
    //OTP = 1234;
    var verifyOtp = /^\d{4}$/;
    if (!this.otpInputVerify.val().match(verifyOtp)) {
      this.otpError.html("Enter the Correct OTP format");
    } else {
      if (OTP == this.otpInputVerify.val()) {
        this.otpError.html("OTP Verified");
        window.$("#verifyOtpModalAccount").modal("hide");
        $("#otpInputVerifyAccount").val("");
        $("#otpErrorAccount").val("");

        //Store Customer details changes in the database
        this.uploadUpdatedProfile();
      } else {
        this.otpError.html("Enter the Correct OTP");
      }
    }
  };

  //SECURITY PAGE

  securityPageValidation = (e) => {
    e.preventDefault();

    //3 validations
    // if (this.toggleChangePasswordBtn.is(":checked")) {
    //NewPassword
    // let isNewPasswordValidated = this.NewPassword_validate();
    // if (isNewPasswordValidated) {
    //
    //   this.New_PasswordError.html("");
    // }

    //CurrentPassword
    let isCurrentPasswordValidated = this.CurrentPassword_validate();
    if (isCurrentPasswordValidated) {
      this.Current_PasswordError.html("");
    }

    //ConfirmPassword
    let isConfirmPasswordValidated = this.ConfirmPassword_validate();
    if (isConfirmPasswordValidated) {
      this.Confirm_PasswordError.html("");
    }

    if (
      // isNewPasswordValidated &&
      isCurrentPasswordValidated &&
      isConfirmPasswordValidated
    ) {
      this.setNewPassword();
    }
  };

  //validate function
  CurrentPassword_validate = () => {
    let flag = true;

    if (
      !(
        this.Current_Password.val().length >= 6 &&
        this.Current_Password.val().length <= 15
      )
    ) {
      this.Current_PasswordError.html(
        "Password must be min 6 and max 15 characters",
      );

      flag = false;
    }

    return flag;
  };

  //validate function
  ConfirmPassword_validate = () => {
    let flag = true;

    if (
      !(
        this.Confirm_Password.val().length >= 6 &&
        this.Confirm_Password.val().length <= 15
      )
    ) {
      this.Confirm_PasswordError.html(
        "Password must be min 6 and max 15 characters",
      );

      flag = false;
    }

    return flag;
  };

  //password validation
  passwordvalidate1 = () => {
    let flag = true;
    if (
      !(
        this.saveNewPasswordInputForgotPassword.val().length >= 6 &&
        this.saveNewPasswordInputForgotPassword.val().length <= 15
      )
      // ||
      // !this.saveNewPasswordInput.val().match(PasswordExample)
    ) {
      this.successNewPasswordForgotPassword.addClass("text-danger");
      this.successNewPasswordForgotPassword.removeClass("text-success");
      this.successNewPasswordForgotPassword.html(
        "Please use min 6 and max 15 characters",
      );

      flag = false;
    }
    return flag;
  };

  //set new password
  setNewPassword = () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;
    // Customer_ID: customerID,Customer_ID: `1e461723-6723-4772-bdcb-bdb0b9bc3eab`,
    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/SetPasswordNew",
      headers: { Authorization: X_API_KEY },
      data: {
        OldPassword: this.Current_Password.val(),
        Password: this.Confirm_Password.val(),
      },
      success: this.NewPasswordUpdate,
      error: this.NewPasswordError,
    });
  };

  NewPasswordUpdate = (res) => {
    //
    window.$("#passwordChangedSuccesfully").modal("show");
    $("#Current_PasswordAccount").val("");
    $("#Confirm_PasswordAccount").val("");
  };

  NewPasswordError = (res) => {
    // $("#Current_PasswordAccount").html(res.Msg);

    this.Current_PasswordError.html(res.responseJSON.Msg);

    //
    //
  };

  sendOtpForgotPassword = (e) => {
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/SendOTPForgotPassword",
      //headers: { Authorization: X_API_KEY },
      data: {
        Phone_Number: this.mobileInputAccount.val(),
      },
      success: (data) => {
        // this.phoneNotRegisteredError.html("OTP Sent Succesfully");
        OTP = String(data?.OTP || data?.otp || "").trim();

        //removinf input for mobile number
        this.mobileLabelForgotPassword.addClass("d-none");
        this.forgotPswdMobileNumberInput.addClass("d-none");
        // this.phoneNotRegisteredError.addClass("d-none");
        this.sendOTPForgotPasswordButton.addClass("d-none");

        //adding input for otp
        this.OTPLabelForgotPassword.removeClass("d-none");
        this.OTPInputForgotPassword.removeClass("d-none");
        this.OTPSuccessForgotPassword.removeClass("d-none");
        this.resendOTPForgotPasswordButton.removeClass("d-none");
        this.verifyOTPBtnForgotPassword.removeClass("d-none");
      },
      error: (err) => {
        // var errMessage = err.responseJSON.Msg;
        // this.phoneNotRegisteredError.html(errMessage);
      },
    });
  };

  //validtaions
  doVerifyOTP = () => {
    let isOTPValidated = this.verifyOtpForgotPassword();
    if (isOTPValidated) {
      this.OTPSuccessForgotPassword.addClass("text-success");
      this.OTPSuccessForgotPassword.removeClass("text-danger");
      this.OTPLabelForgotPassword.addClass("d-none");
      this.OTPInputForgotPassword.addClass("d-none");
      this.resendOTPForgotPasswordButton.addClass("d-none");
      this.verifyOTPBtnForgotPassword.addClass("d-none");
      this.OTPSuccessForgotPassword.addClass("d-none");
      this.newPasswordLabelForgotPassword.removeClass("d-none");
      this.saveNewPasswordInputForgotPassword.removeClass("d-none");
      this.saveNewPasswordBtnForgotPassword.removeClass("d-none");
      $("#otp-labelForgetPasswordAccount").val("");
    }
  };

  verifyOtpForgotPassword = () => {
    let flag = true;
    let OTPExample = /^\d{4}$/;
    const enteredOtp = String(this.OTPInputForgotPassword.val() || "").trim();
    const sentOtp = String(OTP || "").trim();
    if (!enteredOtp.match(OTPExample)) {
      flag = false;
      this.OTPSuccessForgotPassword.addClass("text-danger");
      this.OTPSuccessForgotPassword.removeClass("text-success");
      this.OTPSuccessForgotPassword.html("Enter 4 digit number only ");
    } else {
      if (sentOtp !== "" && sentOtp === enteredOtp) {
        flag = true;
      } else {
        flag = false;
        this.OTPSuccessForgotPassword.addClass("text-danger");
        this.OTPSuccessForgotPassword.removeClass("text-success");
        this.OTPSuccessForgotPassword.html("Enter the Correct OTP");
      }
    }
    return flag;
  };

  doSaveNewForgotPassword = () => {
    let newPassword = this.saveNewPasswordInputForgotPassword.val();
    let newPassValidation = this.passwordvalidate1();

    if (newPassValidation) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/vendor/UpdatePassword",
        headers: { Authorization: X_API_KEY },

        data: {
          Password: newPassword, //Password column name
          Phone_Number: this.mobileInputAccount.val(),
        },

        //headers: { Authorization: X_API_KEY },

        success: (res) => {
          $("#otp-labelForgetPasswordAccount").val("");
          $("#newForgetPasswordAccount").val("");
          $("#success-New-PasswordAccount").html("");
          $("#OTP-successAccount").html("");
          $("#otp-inputForgetPasswordAccount").val("");

          window.$("#forgotpassModalForServicingSecurityPage").modal("hide");
          window.$("#passwordChangedSuccesfully").modal("show");

          //reset forgot pssword to original
          this.sendOTPForgotPasswordButton.removeClass("d-none");
          this.forgotPswdMobileNumberInput.removeClass("d-none");
          this.mobileLabelForgotPassword.removeClass("d-none");
          this.saveNewPasswordBtnForgotPassword.addClass("d-none");
          this.newPasswordLabelForgotPassword.addClass("d-none");
          this.saveNewPasswordInputForgotPassword.addClass("d-none");
        },
      });
    }
  };
}

